import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Elements
import { ModalBodyWrapper } from './DeleteAiDocModal.elements'

// Views
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'views/components'

// Hooks
import { useDeleteDocument } from 'core/hooks/api'
import { useHistory } from 'react-router-dom'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function DeleteAiDocModal(props) {
  // Destructure
  const { ui, actions, ai } = props

  // Store State
  const { isDeleteAiDocModalOpen } = ui
  const { documentToDeleteID } = ai

  // Store Actions
  const { toggleDeleteAiDocModalOpen, setDocumentToDeleteID } = actions

  // Hooks
  const { deleteDocument, deleteDocumentError, isDeleteDocumentLoading } = useDeleteDocument()

  const history = useHistory()

  // Functions
  const toggleModal = () => {
    toggleDeleteAiDocModalOpen()
  }
  const handleDelete = () => {
    deleteDocument({ document_id: documentToDeleteID })
  }

  // UseEffect
  useEffect(() => {
    if (isDeleteAiDocModalOpen) {
      if (!isDeleteDocumentLoading && !deleteDocumentError) {
        setDocumentToDeleteID()
        toggleDeleteAiDocModalOpen()
        history.push('/admin/ai/documents')
      }
    }
  }, [isDeleteDocumentLoading])
  return (
    <Modal isOpen={isDeleteAiDocModalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Delete Document</ModalHeader>
      <ModalBody>
        {isDeleteDocumentLoading && <ModalBodyWrapper>Deleting Document...</ModalBodyWrapper>}
        {!isDeleteDocumentLoading && !deleteDocumentError && (
          <ModalBodyWrapper>Are you sure you want to delete this document?</ModalBodyWrapper>
        )}
        {!isDeleteDocumentLoading && deleteDocumentError && (
          <ModalBodyWrapper>An error occurred in deleting document, please try again later.</ModalBodyWrapper>
        )}
      </ModalBody>
      <ModalFooter>
        <Button fullWidth type="button" onClick={toggleModal} variant="outlined" disabled={isDeleteDocumentLoading}>
          Cancel
        </Button>
        <Button fullWidth type="button" onClick={handleDelete} color="secondary" disabled={isDeleteDocumentLoading}>
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  )
}

// Default Props
DeleteAiDocModal.defaultProps = {
  ui: {},
  form: {},
  actions: {},
}

// Proptypes Validation
DeleteAiDocModal.propTypes = {
  ui: PropTypes.shape({ isDeleteAiDocModalOpen: PropTypes.bool }),
  form: PropTypes.shape({
    activityToRemove: PropTypes.shape({
      type: PropTypes.string,
      hash: PropTypes.string,
    }),
  }),
  ai: PropTypes.shape({
    documentToDeleteID: PropTypes.shape({ user_id: PropTypes.string, is_active: PropTypes.bool }),
  }),
  actions: PropTypes.shape({
    toggleDeleteAiDocModalOpen: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setDocumentToDeleteID: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAiDocModal)
